
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ZInputGroup',

  props: {
    prefix: {
      type: String,
      default: ''
    },
    addonBgColor: {
      type: String,
      default: 'bg-ink-200'
    }
  },
  data() {
    return {
      inputInFocus: false
    }
  },
  computed: {
    addonClasses(): string {
      const classMap: Record<string, string> = {
        'x-small': 'h-6 text-xs leading-loose',
        small: 'h-8 text-xs leading-loose',
        medium: 'h-10 text-sm leading-8',
        large: 'h-12 text-base leading-9',
        'x-large': 'h-13 text-lg leading-9',
        xlarge: 'h-13 text-lg leading-9'
      }

      return classMap[this.$attrs.size || 'medium']
    }
  }
})
